<template>
  <div>
    <TestReports></TestReports>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const TestReports = defineAsyncComponent(() =>
  import("@/components/cases/ViewTestReport")
);
export default {
  components: {
    TestReports,
  },
};
</script>
